// redux/leads-queue/selectors.ts
import { RootState } from "../store";
import { createSelector } from "@reduxjs/toolkit";

export const selectCompanies = (state: RootState) => state.leadsQueue.companies;
export const selectActiveCompany = (state: RootState) =>
  state.leadsQueue.activeCompany;

export const selectLeadForms = (state: RootState) => state.leadsQueue.leadForms;
export const selectQueueFormId = (state: RootState) => state.leadsQueue.formId;

export const selectCompaniesLoading = (state: RootState) =>
  state.leadsQueue.loadingCompanies;
export const selectFormsLoading = (state: RootState) =>
  state.leadsQueue.loadingForms;

export const selectPageLoading = (state: RootState) =>
  state.leadsQueue.loadingCompanies || state.leadsQueue.loadingForms;

export const selectCompanyOptions = createSelector(
  [selectCompanies],
  (companies) =>
    companies.map((company) => ({
      value: `${company.id}-${company.type}`,
      label: `${company.name} - ${company.type}`,
    })),
);
